import { html } from "lit-html";
import i18next from "i18next";
export const registrationInfoTemplate = () => {
  if (ClientContext.TenantName !== "amazon") {
    return "";
  }
  return html` <div class="text-xl md:text-3xl font-bold mt-8 text-center">${i18next.t("Exclusive to Amazon Sellers")}</div>
		<div class="mt-4 text-center mb-4 text-sm">${i18next.t("exclusive-amazon-sellers-details")}</div>
		<div class="text-xl md:text-3xl font-bold mt-8 text-center">${i18next.t("Why choose Tax Desk")}</div>
		<div class="mt-4 text-center text-sm">${i18next.t("why-choose-tax-desk-details-1")}</div>
		<div class="mt-4 text-center mb-4 text-sm">${i18next.t("why-choose-tax-desk-details-2")}</div>`;
};
export const registrationMessageTemplate = () => {
  if (ClientContext.TenantName !== "amazon") {
    return "";
  }
  return html` <div class="mt-4 text-center mb-4 text-sm">${i18next.t("amazon-create-account-message")}</div>`;
};
